import React from 'react';
import cx from 'classnames';
import { Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from '../RegionReport.css';
import { getAverageYieldText } from '../../../../utils/regionUtils'

export type RegionReportItemHeaderProps = {
  areaUnit: string;
  cropCode: string;
  headerText: string;
  isCollapsed: boolean;
  toggleCollapsed: () => void;
};
export const RegionReportItemHeader = ({
  areaUnit,
  cropCode,
  headerText,
  isCollapsed,
  toggleCollapsed,
}: RegionReportItemHeaderProps) => {
  const averageYieldText = getMessage(getAverageYieldText(cropCode));

  return (
    <div className={cx(styles.content, styles.contentHeader)} data-test-id="frr-header-item">
      <div className={styles.first}>
        {isCollapsed ? (
          <Icon glyph={Icon.set.ARROW_DOWN} onClick={toggleCollapsed} />
        ) : (
          <Icon glyph={Icon.set.ARROW_UP} onClick={toggleCollapsed} />
        )}
        <span className={styles.reportItemHeaderText} data-test-id={`frr-header-item-${headerText}`}>{headerText}</span>
      </div>
      <div data-test-id="dmb-region-report-item-header-area-unit-text">
        {areaUnit}
      </div>
      <div data-test-id="dmb-region-report-item-header-avg-yield-text" className={styles.last}>
        {averageYieldText}
      </div>
    </div>
  );
};
